/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ProgressButton {
  static initClass() {
    this.INSTANCE_KEY = 'progress_button_instance';
  }
  constructor(element) {
    let method;
    let context = (method = null);
    this.$el = $(element);
    this.textSetter = 'text';

    if ((this.$el.is('input') || this.$el.is('button[type="submit"]')) && this.$el.parents('form').length) {
      context = this.$el.parents('form');
      method = 'submit';
    } else {
      context = this.$el;
      method = 'click';
    }

    if (this.$el.is('input')) { this.textSetter = 'val'; }
    this.originalText = this.$el[this.textSetter]();

    context.on(method, e => {
      this.$el.width(this.$el.width());
      this.$el.addClass('flashing-text')[this.textSetter](this.$el.data('progresstext'));
      return window.requestAnimationFrame(() => {
        return this.$el.attr('disabled', 'disabled');
      });
    });
  }

  reset() {
    this.$el[this.textSetter](this.originalText).removeAttr('disabled');
    return this.$el.removeClass('flashing-text');
  }

  confirm() {
    this.$el.removeClass('flashing-text');
    this.$el[this.textSetter](this.$el.data('confirmtext'));
    return setTimeout($.proxy(this.reset, this), 1000);
  }
}
ProgressButton.initClass();

$.fn.progressButton = function(apiMethod = null) {
  const instanceKey = ProgressButton.INSTANCE_KEY;
  return this.each(function() {
    let instance = $(this).data(instanceKey);

    if (instance == null) {
      instance = new ProgressButton(this);
      $(this).data(instanceKey, instance);
    }

    if (apiMethod != null) {
      return instance[apiMethod]();
    }
  });
};
